import { getSelectedSiteCountry } from '@/config'
import BankAccountFormFieldsNg from './BankAccountFormFieldsNg.vue'
import BankAccountFormFieldsBr from './BankAccountFormFieldsBr.vue'
import BankAccountFormFieldsIn from './BankAccountFormFieldsIn.vue'

/** 与 H5 withdraw.page 一致：按站点国家渲染不同提款账户表单（优先当前所选站点） */
export function getBankAccountSiteCountry() {
  return getSelectedSiteCountry() || process.env.VUE_APP_NATIONAL || 'br'
}

export const BANK_ACCOUNT_FORM_FIELDS_MAP = {
  ng: BankAccountFormFieldsNg,
  br: BankAccountFormFieldsBr,
  in: BankAccountFormFieldsIn,
}

export function resolveBankAccountFormFieldsComponent(country = getBankAccountSiteCountry()) {
  return BANK_ACCOUNT_FORM_FIELDS_MAP[country] || BANK_ACCOUNT_FORM_FIELDS_MAP.ng
}
